import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  declare urlValue: string
  declare printFrame?: HTMLIFrameElement

  connect(): void {
    const printFrame = document.createElement('iframe')

    // Keep the frame out of sight without nesting it under `.hidden`.
    printFrame.style.position = 'absolute'
    printFrame.style.width = '0'
    printFrame.style.height = '0'
    printFrame.style.border = '0'
    printFrame.style.visibility = 'hidden'
    printFrame.src = this.urlValue

    printFrame.onload = () => {
      if (printFrame.contentWindow !== null) {
        printFrame.contentWindow.focus()
        printFrame.contentWindow.print()
      }
    }

    this.printFrame = printFrame
    document.body.appendChild(printFrame)
  }

  disconnect(): void {
    this.printFrame?.remove()
  }
}
